/*eslint eqeqeq: [ 0 ]*/
import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import { Grid, Typography, FormControl, Select, InputLabel, FormHelperText, Button, Input, InputAdornment, TextField } from '@material-ui/core';
import 'rc-slider/assets/index.css';
import Slider from 'rc-slider';
import { FormatYear } from '../CommonComponents';
import { CalculatorConsumer } from './CalculatorProvider';
import ChevronRight from '@material-ui/icons/ArrowForwardIos';
import NumberFormat from 'react-number-format';

const styles = theme => ({
  rightIcon: {
    position: 'relative',
    left: '7px',
  },
  container: {
    display: 'flex',
    flexWrap: 'wrap',
  },
  textField: {
    '& input': {
      fontSize: '1.5rem',
      textAlign: 'center'
    },
    '& p': {
      textAlign: 'center'
    }
  },
});

function NumberFormatCustom(props) {
  const { inputRef, onChange, ...other } = props;

  return (
    <NumberFormat
      {...other}
      getInputRef={inputRef}
      onValueChange={values => {
        onChange({
          target: {
            value: values.value,
          },
        });
      }}
      thousandSeparator
      prefix="PHP"
    />
  );
}


const RenderInvestmentSlider = withStyles(styles)(function ({ classes, investmentInput }) {
  return (
    <CalculatorConsumer>
      {context => (
        <Fragment>
          <div style={{marginTop: '16px'}}>
            <Typography variant="body1" gutterBottom align="center">How much do you want to invest?</Typography>
            {investmentInput === true
              ? '' // hide slider if == 490000
              : // display slider
              <Fragment>
                <Grid container justify="center">
                  <TextField
                    // id="standard-name"
                    className={classes.textField}
                    value={context.state.investment}
                    onChange={context.handleInvestmentField('investment')}
                    margin="normal"
                    id="formatted-numberformat-input"
                    helperText="Input amount"
                    InputProps={{
                      inputComponent: NumberFormatCustom,
                    }}
                  />
                </Grid>

                <div style={{ width: '100%', margin: '10px 0 0' }}>
                  <Slider
                    step={context.state.increment}
                    min={context.state.minInvestment}
                    max={context.state.maxInvestment}
                    defaultValue={context.state.startInvestment}
                    value={context.state.investment}
                    onChange={context.handleInvestment}
                  />
                </div>
                {/* amount markers */}
                <div className="rc-slider-mark"  style={{position: 'relative', top: '0%', marginBottom: '50px'}}>
                  <span className="rc-slider-mark-text" style={{left: '0%'}}> P{context.state.minInvestment.toLocaleString('en')} </span>
                  <span className="rc-slider-mark-text" style={{ right: '-5%'}}> P{context.state.maxInvestment.toLocaleString('en')} </span>
                </div>
              </Fragment>
            }

          </div>
        </Fragment>
      )}
    </CalculatorConsumer>
  )
})

class RenderCalculator extends Component {
  render() {
    const { classes } = this.props;
    const marks = {
      30: '30 days',
      60: '60D',
      90: '90D',
      180: '180D',
      270: '270D',
      360: '1 year',
      720: '2 years',
      1080: '3 years',
      1440: '4 years',
      1800: '5 years'
    };
    return (
      <CalculatorConsumer>
        {context => (
          <Fragment>
            <FormControl style={{ width: '100%' }}>
              <InputLabel htmlFor="age-native-simple">At What Stage Are You in Life?*</InputLabel>
              <Select
                native
                value={context.state.lifestage}
                onChange={context.handleChange('lifestage')}
                inputProps={{
                  name: 'lifestage',
                  id: 'select-stage',
                }}
              >
                <option value=""></option>
                <option value="Single/Independent">Single/Independent</option>
                <option value="Starting a life together">Starting a life together</option>
                <option value="Family with Young Kids">Family with Young Kids</option>
                <option value="Family with Grown Up Kids">Family with Grown Up Kids</option>
                <option value="Empty Nester">Empty Nester</option>
                <option value="Retiree">Retiree</option>
              </Select>
              <FormHelperText>Please Select Your Life Stage</FormHelperText>
            </FormControl>
            {context.state.lifestage === ''
              ? '' // hide investment and tenor sliders
              : // render investment and tenor sliders
              <Fragment>
                {context.state.lifestage === "Single/Independent" || context.state.lifestage === "Starting a life together" || context.state.lifestage === "Family with Young Kids" || context.state.lifestage === "Family with Grown Up Kids"
                  ? //extended investment
                  <Fragment>
                    <RenderInvestmentSlider investmentInput={context.state.investmentInput} />
                    {
                      context.state.investment != 490000
                        ?
                        <Fragment>
                          {context.state.investmentInput === true
                            ?
                            <FormControl fullWidth style={{ marginTop: '20px' }}>
                              <InputLabel htmlFor="investment"><Typography variant="h6" gutterBottom>Enter amount to invest</Typography></InputLabel>
                              <Input
                                id="investment"
                                type="number"
                                value={context.state.investment}
                                onChange={context.handleExtendedInvestment('investment')}
                                startAdornment={<InputAdornment position="start"><Typography variant="h5">P</Typography></InputAdornment>}
                                className={classes.textField}
                                autoFocus
                                error={context.state.amountErrorMsg !== ''}
                              />
                              <FormHelperText>{context.state.amountErrorMsg}</FormHelperText>
                            </FormControl>
                            : ''
                          }
                        </Fragment>
                        :
                        <Fragment>
                          {context.state.investmentInput === true
                            ?
                            <FormControl fullWidth style={{ marginTop: '20px' }}>
                              <InputLabel htmlFor="investment"><Typography variant="h6" gutterBottom>Enter amount to invest</Typography></InputLabel>
                              <Input
                                id="investment"
                                type="number"
                                value={context.state.investment}
                                onChange={context.handleExtendedInvestment('investment')}
                                startAdornment={<InputAdornment position="start"><Typography variant="h5">P</Typography></InputAdornment>}
                                className={classes.textField}
                                autoFocus
                                error={context.state.amountErrorMsg !== ''}
                              />
                              <FormHelperText>{context.state.amountErrorMsg}</FormHelperText>
                            </FormControl>
                            :
                            <div style={{ textAlign: 'center', marginTop: '20px' }}>
                              <Typography variant="body1" gutterBottom>Are you interested in investing more?</Typography>
                              <Button color="secondary" variant="contained" size="large" onClick={e => context.onSubmit(e)}>YES, I'M INTERESTED <ChevronRight className={classes.rightIcon} /></Button>
                            </div>
                          }
                        </Fragment>
                    }
                  </Fragment>
                  : // for empty nester and retiree
                  <RenderInvestmentSlider />
                }
                <div style={{marginTop: '16px'}}>
                  <Typography variant="body1" gutterBottom align="center">How long would like to invest in Time Deposit?</Typography>
                  <FormatYear days={context.state.investmentTime} />
                  <div style={{ width: '100%', margin: '0' }}>
                    <Slider
                      min={30}
                      max={1800}
                      defaultValue={30}
                      step={null}
                      marks={marks}
                      value={context.state.investmentTime}
                      onChange={context.handleTenor}
                    />
                  </div>
                </div>
              </Fragment>
            }
          </Fragment>
        )}
      </CalculatorConsumer>
    )
  }
}

RenderCalculator.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(RenderCalculator);